import { LockSimple } from '@phosphor-icons/react';
import { t } from 'i18next';

import { Tooltip } from 'core/elements';
import { renderHtmlMessage } from 'core/utils';
import { QuotePartHelper } from 'quotes/helpers';
import { ICustomerQuotePart } from 'quotes/types';
import { theme } from 'theme';
import { Color, TooltipPosition } from 'theme/enums';

export const CostLockTooltip = ({
  quotePart = null,
  costLocked = false,
  placement = TooltipPosition.BOTTOM_START,
  tooltipTitle = t('labelExternalCostLocked'),
}: {
  quotePart?: ICustomerQuotePart;
  costLocked?: boolean;
  placement?: TooltipPosition;
  tooltipTitle?: string;
}) => {
  const isCostLocked = costLocked || QuotePartHelper.isCostLocked(quotePart);

  if (!isCostLocked) {
    return <></>;
  }

  return (
    <Tooltip
      title={renderHtmlMessage(tooltipTitle)}
      color={Color.DANGER}
      placement={placement}
      sx={{ justifyContent: 'center' }}
    >
      <LockSimple
        weight="fill"
        style={{ color: `rgba(${theme.palette?.danger.mainChannel} / 1)` }}
      />
    </Tooltip>
  );
};
